import { Suspense } from 'react';
import { Route, Routes } from 'react-router-dom';

import { ErrorPage } from '~/components/ErrorPage';
import { ErrorBoundary } from '~/modules/errors/components/ErrorBoundary.tsx';

import { WmgOneLayout } from './components/WmgOneLayout';
import { Home } from './Home.tsx';
import { LinkPage } from './LinkPage.tsx';
import { LINK_FARM_CATEGORIES } from './types.ts';

export function LinkFarmRouter() {
  return (
    <ErrorBoundary>
      <Suspense>
        <Routes>
          <Route element={<WmgOneLayout />}>
            <Route index path="/" element={<Home />} />
            {LINK_FARM_CATEGORIES.map((category) => {
              return (
                <Route
                  key={category}
                  path={category}
                  element={<LinkPage category={category} />}
                />
              );
            })}
          </Route>
          <Route path="*" element={<ErrorPage type="notFoundPage" />} />
        </Routes>
      </Suspense>
    </ErrorBoundary>
  );
}

LinkFarmRouter.displayName = 'LinkFarmRouter';
